import { Breadcrumbs, Typography, useTheme } from "@mui/material";
import React, { FC } from "react";
import { Flue } from "./Flue";
import { _throw, IllegalStateError } from "shared-ts-utils-core";
import { useTranslation } from "react-i18next";

export interface FlueBreadcrumbsProps {
  flue: Flue;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  noWrap?: boolean;
}

export const FlueBreadcrumbs: FC<FlueBreadcrumbsProps> = (props) => {
  const { flue } = props;
  const theme = useTheme();
  const noWrap = props.noWrap ?? false;
  const { t } = useTranslation("my-chimney-ts-translations");
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    props.onClick?.(event);
  };
  const chimney =
    flue.chimney ??
    _throw(new IllegalStateError("chimney not set on flue: " + flue.id));

  let chimneyLabel = "";
  if (chimney.mcFields?.name != null) {
    chimneyLabel += chimney.mcFields?.name;
  } else {
    chimneyLabel += t("Chimney");
  }

  let flueLabel = "";
  if (flue.fields?.mcName != null) {
    flueLabel += flue.fields?.mcName;
  } else {
    flueLabel += t("Flue");
  }

  if (flue.fields.shared) {
    flueLabel += ` (${t("Shared")})`;
  }

  return (
    <Breadcrumbs
      onClick={handleClick}
      sx={{
        color: theme.palette.text.primary,
        ".MuiBreadcrumbs-ol": { flexWrap: noWrap ? "nowrap" : undefined },
      }}
    >
      <Typography title={t("Chimney")}>{chimneyLabel}</Typography>
      <Typography title={t("Flue")}>{flueLabel}</Typography>
    </Breadcrumbs>
  );
};
